import { usePremiumPackage } from "../../../../hooks/usePremiumPackage";
import { Container } from "../../../common/Container/Container";
import { FlightLogsCesium } from "./FlightLogsCesium";

import "cesium/Build/Cesium/Widgets/widgets.css";
import "./flight_logs.scss";

export type TLocation = {
	latitude: number;
	longitude: number;
	altitude: number;
	mslAltitude?: number;
	speed: number;
	time: number;
	accuracy: number;
	bearing: number;
	provider: string;
	satellites: number[];
	heading?: number;
	pitch?: number;
	roll?: number;
	elevation?: number;
	cesiumHeight?: number;
	calculatedData?: {
		wind: { windSpeed: number; windDirection: number };
	};
};

export function FlightLogs() {
	const { loading } = usePremiumPackage();

	if (loading) {
		return <Container loading noFooter />;
	}

	return <FlightLogsCesium />;
}
